<template>
  <v-container fluid class="pa-0">
    <DialogSelectPeergroup ref="dlgSelectPeergroup" @doItem="loadPeergroup" @doReload="loadPGList"></DialogSelectPeergroup>
    <v-layout row fluid>
      <div>
        <searchMask :ankerBank="balance" balanceName="Peergroup" ref="SearchMask1" eventName="OnGetHitList"
                    configName="hitlistpgSearch" tableName="" @onSubmit="onSubmit"
                    @collapseEvent="collapseEvent" eventNameSubmit="OnStartSubmitPeergroup"></searchMask>
      </div>
      <v-flex style="padding: 0px; margin: 0px;">
        <v-card flat style="padding: 0px; margin: 0px;">
          <v-card-text style="padding: 0px; margin: 0px;">
            <FixedTableIE :widthSub="widthSub" :heightSub="getHeightSub()" :ankerBank="null" ref="sdTable"
                          :currency="currentCurrency"
                          :selected="selected"
                          configSuffix="hitlistpgSearch" tableName=""
                          :headerConfigName="'Peergroup'"
                          @selectedRows="selectedRows"
                          :tableConfig='tableConfig' :tableNotComplete="tableNotComplete"
                          :headers="headers" :items="pgresults" class="colorrows isactive"></FixedTableIE>
            <div v-if="((pgresults === null))" class="font-weight-bold bluetext textleft missingDataInPeergroup">{{
              'TITLE_PEERGROUP_SELECT_FILTERS' | translate}}
            </div>
          </v-card-text>
          <v-card-actions>
            <!--
            <v-btn small color='#004884' dark class="text-none mx-3" outline @click="forwardToOverview">{{
              'BUTTON_FORWARD_TO_PGOVERVIEW' | translate}}
            </v-btn>
            -->
            <v-btn color="#004884" class="text-none" outline small @click="showLoadPGDialog()">{{ 'BUTT_LOAD_PEERGROUP'
              | translate}}
            </v-btn>
            <v-spacer></v-spacer>
            <HitlistCounter></HitlistCounter>
            &nbsp; &nbsp;
            <span v-if="sRows" class="font-weight-bold bluetext">&nbsp;{{ 'TABLE_SELECTION_COUNT' | translate}}: {{sRows}}</span>

            <v-spacer></v-spacer>

            <!--
            <v-btn v-if="(pgresults != null) && (pgresults.length > 0) && shwButton" small color='blue' dark class="text-none mx-3" @click="addModelsToGroup(false)">{{ 'BUTT_ADD_NO_FORWARD' | translate}}</v-btn>
            <v-btn v-if="(pgresults != null) && (pgresults.length > 0) && shwButton" small color='blue' dark class="text-none mx-3" @click="addModelsToGroup(true)">{{ 'BUTT_ADD' | translate}}</v-btn>
            -->
            <v-btn v-if="(pgresults != null) && (pgresults.length > 0) && shwButton" small color='blue' dark class="text-none mx-3" @click="forwardToOverview()">{{ 'BUTTON_FORWARD_TO_PGOVERVIEW' | translate}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import SearchMask from './mask/SearchMaskv2'
  import Vue from 'vue'
  import FixedTableIE from './../tables/EasyTableIE'
  import HitlistCounter from "../widgets/HitlistCounter"
  import DialogSelectPeergroup from './../module/dialogs/DialogSelectPeergroup';

  export default {
    name: 'Peergroup.vue',
    components: {HitlistCounter, SearchMask, FixedTableIE, DialogSelectPeergroup},
    data() {
      return {
        userPGList: [],
        link: '',
        balance: null,
        target: '',
        first: true,
        myData: null,
        widthSub: 370,
        s: true,
        tableNotComplete: false,
        shwButton: false,
        headers: [],
        pgresults: null,
        showForward: true,
        maskHeight: 580,
        sRows: '',
        currentCurrency: '1',
        storeOldPeergroup: null,
        bankAnchor: null,
        selected: [],
        idModule: '',
        idModuleItem: '',
        'tableConfig': {
          selection: true,
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
      }
    },
    methods: {
      collapseEvent: function (isMini) {
        if (isMini) {
          this.widthSub = 96
        } else {
          this.widthSub = 370
        }
      },
      getHeightSub() {
        return 62
      },
      loadPGList() {
        Vue.prototype.$api.getPeergroupList(this.onGetPeergroupList)
      },
      onGetPeergroupList(list) {
        Vue.prototype.$api.debug('onGetPeergroupList', list)
        this.userPGList = list
      },
      loadPeergroup(pgId) {
        Vue.prototype.$api.debug('loadPeergroup', pgId)
        Vue.prototype.$api.loadPeergroupListById(pgId, this.onGetPeergroupLisById)
      },
      onGetPeergroupLisById(list) {
        Vue.prototype.$api.debug('onGetPeergroupLisById', list)
        this.loadedPGList = list.balanceArray
        Vue.prototype.storage.ankerBank = null
        Vue.prototype.storage.hasAnkerBank = false
        Vue.prototype.storage.peergroupData[Vue.prototype.$api.getModuleId()] = []
        Vue.prototype.storage.peergroupDataRows[Vue.prototype.$api.getModuleId()] = []

        Vue.prototype.storage.resetAnkerbank(Vue.prototype.$api.getModuleId())
        if (list.ankerBank) {
          this.hasAnkerBank = true
          Vue.prototype.storage.hasAnkerBank = true
          Vue.prototype.storage.ankerBank = Vue.prototype.$api.stringToBalance(list.ankerBank)
          this.ankerBank = Vue.prototype.storage.ankerBank
          Vue.prototype.storage.setAnkerbank(Vue.prototype.$api.getModuleId(), Vue.prototype.storage.ankerBank)
          Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
            title: '',
            balance: Vue.prototype.storage.ankerBank
          })
        }
        this.headerFields = [{
          type: 'nm',
          id: 'crefoNr'
        }, {
          type: 'nm',
          id: 'companyName'
        }, {
          type: 'nm',
          id: 'country'
        }, {
          type: 'nm',
          id: 'year'
        }, {
          type: 'nm',
          id: 'aa'
        }, {
          type: 'nm',
          id: 'rk'
        }, {
          type: 'nm',
          id: 'source'
        }]
        Vue.prototype.$api.getBalanceDataWithBalanceStringArray(list.balanceArray, this.headerFields, this.onGetBalances)
      },
      onGetBalances(tableData) {
        Vue.prototype.$api.debug('onGetBalances', tableData)
        var result = Vue.prototype.$api.prepareWaimeaTable(tableData.table)
        this.pgresults = result.rows

        let missingTitle = false
        if (this.ankerBank) {
          if (Vue.prototype.storage.getAnkerbankData(Vue.prototype.$api.getModuleId()).title === '') {
            missingTitle = true
          }
        }

        var pgData = []
        for (var i in this.pgresults) {
          var item = this.pgresults[i]
          if (this.hasAnkerBank) {
            if (Vue.prototype.$api.compareBalance(item.meta.balance, Vue.prototype.storage.ankerBank)) {
              item.meta.balance.isAnkerBank = true
              if (missingTitle) {
                Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
                  title: item[1].co,
                  balance: Vue.prototype.storage.ankerBank
                })
              }
            }
          }
          pgData.push(item.meta.balance)
        }

        Vue.prototype.storage.setPeergroup(Vue.prototype.$api.getModuleId(), pgData)

        this.$router.push(this.linkOverview)

      },

      openTable: function () {
        Vue.prototype.$api.debug('openTable')
        let cmp = this
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          let orderCellName = null
          if (!this.$refs.sdTable.orderIsSet()) {
            for (var i = 0;i < this.headers.length; i++) {
              let headItem = this.headers[i]
              if (headItem.meta.id.indexOf('Name') > -1) {
                orderCellName = i + 1
                cmp.first = false
                break;
              }
            }
          }

          this.$refs.sdTable.updateHeader(this.headers)
          this.$refs.sdTable.updateData(this.pgresults, true, orderCellName)
          this.shwButton = true
          window.setTimeout(function () {
            cmp.selectedRows({
              selected: cmp.$refs.sdTable.getSelectedRows(),
              selectedBefore: []
            })
          }, 100)

        }
        Vue.prototype.$api.debug('openTable done')
      },
      selectedRows(rows) {
        this.sRows = ''
        if (rows && rows.selected.length > 0) {
          this.sRows = '' + rows.selected.length
        }
        this.removeModelsFromGroup(false, rows.selectedBefore)
        this.addModelsToGroup(false)
        Vue.prototype.$eventHub.$emit('hitlistcounter', {
          hits: this.myData.table.rows.length,
          totalHits: this.myData.totalHits,
          totalHitsAppendix: this.myData.totalHitsAppendix
        })

        // this.updateSelectedEntries(this.pgresults)
        // this.openTable()
      },
      forwardToOverview() {
        this.$refs.sdTable.clearMemoryLeaks()
        this.$router.push(this.linkOverview)
      },
      showLoadPGDialog() {
        this.$refs.dlgSelectPeergroup.open(this.userPGList)
      },
      removeModelsFromGroup(doForward, models) {
        Vue.prototype.$eventHub.$emit('EventStoreSearchData')
        this.selected = this.$refs.sdTable.getSelected()
        Vue.prototype.$api.debug('removeModelsFromGroup', models)
        for (var itemIndex in models) {
          var item = models[itemIndex]
          if (item.meta.balance.isAnkerBank) continue
          Vue.prototype.storage.deleteFromPeergroup(Vue.prototype.$api.getModuleId(), item.meta.balance)
        }
        if (doForward) {
          this.$refs.sdTable.clearMemoryLeaks()
          this.$router.push(this.linkOverview)
        }
      },
      addModelsToGroup(doForward) {
        Vue.prototype.$eventHub.$emit('EventStoreSearchData')
        this.selected = this.$refs.sdTable.getSelected()
        Vue.prototype.$api.debug('addModelsToGroup', this.selected)
        var pgList = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())
        for (var itemIndex in this.selected) {
          var item = this.selected[itemIndex]
          var aString = Vue.prototype.$api.balanceToString(item.meta.balance)
          var idx = _.findIndex(pgList, function (storageItem) {
            var bString = Vue.prototype.$api.balanceToString(storageItem)
            return (aString === bString)
          })
          var alreadyExists = idx > -1
          if (!alreadyExists) {
            Vue.prototype.storage.addToPeergroup(Vue.prototype.$api.getModuleId(), item.meta.balance, item)
          }
        }
        if (doForward) {
          this.$refs.sdTable.clearMemoryLeaks()
          this.$router.push(this.linkOverview)
        }
      },
      open: function () {
        this.headers = []
        var result = Vue.prototype.$api.prepareWaimeaTable(this.myData.table)
        this.pgresults = result.rows
        this.headers = result.headers

        Vue.prototype.storage.currentHeader = this.headers

        Vue.prototype.$api.debug('updateSelectedEntries')
        this.updateSelectedEntries(this.pgresults)
        Vue.prototype.$api.debug('updateSelectedEntries done')
        if (this.myData && this.myData.table && this.myData.table.rows && this.myData.table.rows) {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: this.myData.table.rows.length,
            totalHits: this.myData.totalHits,
            totalHitsAppendix: this.myData.totalHitsAppendix
          })
        } else {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: -1,
            totalHits: -1,
            totalHitsAppendix: ''
          })
        }
        Vue.prototype.storage.saveState('pgoverviewHeader', result.headers)

        this.openTable()
      },
      updateSelectedEntries(data) {
        var ankerBankFound = false
        for (var index in data) {
          var item = data[index].meta
          item.selected = false
          item.value = 0
          if (Vue.prototype.storage.hasAnkerBank) {
            if (Vue.prototype.$api.compareBalance(item.balance, Vue.prototype.storage.ankerBankBalance)) {
              item.selected = true
              item.value = 1
              ankerBankFound = false
            }
          }
          //if (Vue.prototype.$api.checkBalanceExistsInGroup(item.balance)) {
          if (Vue.prototype.storage.isInPeergroup(item.balance)) {
            item.selected = true
            item.value = 1
          }
        }
      },
      close: function () {
        Vue.prototype.$api.debug('close')
        if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
          this.$refs.sdTable.doDestroyTable()
        }
      },
      onGetHitList: function (data) {
        Vue.prototype.$api.debug('onGetHitList', data)
        this.myData = data
        Vue.prototype.storage.saveState('pgLastHitList_' + this.target, this.myData)
        this.open()
      },
      onSubmit: function () {
        // console.log('onSubmit')
        this.sRows = ''
      },
      onBackButtonClick: function (source) {
        console.log('onBackButtonClick', source)
        Vue.prototype.storage.resetPeergroup(Vue.prototype.$api.getModuleId())
        if (JSON.parse(this.storeOldPeergroup)) {
          Vue.prototype.storage.setPeergroup(Vue.prototype.$api.getModuleId(), JSON.parse(this.storeOldPeergroup))
        }

      }
    },
    created() {
      Vue.prototype.$eventHub.$on('OnGetHitList', this.onGetHitList)
      Vue.prototype.$eventHub.$on('OnBackButtonClick', this.onBackButtonClick)

    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnGetHitList', this.onGetHitList)
      Vue.prototype.$eventHub.$off('OnBackButtonClick', this.onBackButtonClick)
    },
    mounted() {
      var cmp = this
      cmp.first = true
      var view = Vue.prototype.$api.viewport()
      var footerHeight = 0
      this.currentCurrency = Vue.prototype.storage.getCurrency()

      this.storeOldPeergroup = JSON.stringify(Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()))
      if ($('#footerMenu')) {
        footerHeight = $('#footerMenu').height()
      }
      var h2 = view.height - footerHeight - Vue.prototype.storage.appConfig.TABLE_SHRINK_HEIGHT + 34
      cmp.maskHeight = h2

      this.showForward = true
      if (!Vue.prototype.storage.isPeergroup(Vue.prototype.$api.getModuleId())) {
        this.showForward = false
      }
      Vue.prototype.$eventHub.$emit('hitlistcounter', {
        hits: -1,
        totalHits: -1,
        totalHitsAppendix: ''
      })


      Vue.prototype.$api.checkCredentials(cmp, function () {
        if (cmp.$route.params) {
          cmp.idModule = cmp.$route.params.idModule
          cmp.idModuleItem = cmp.$route.params.idModuleItem

          if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
            Vue.prototype.storage.ankerBank = Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId())
            Vue.prototype.storage.hasAnkerBank = true
          } else {
            cmp.balance = null
          }

          cmp.target = cmp.idModule + '_Peergroup'
          Vue.prototype.$api.debug('target', cmp.target)
          cmp.myData = Vue.prototype.storage.getState('pgLastHitList_' + cmp.target)
          if (cmp.myData) {
            cmp.open()
          }

        }
        Vue.prototype.$api.getBreadCrumpModule(cmp.idModule)
        cmp.link = '/di/StructureData/' + cmp.idModule
        cmp.linkOverview = '/di/peergroup/' + cmp.idModule + '/overview'
        cmp.loadPGList()
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/Peergroup.vue